import has from 'lodash/has.js';
import includes from 'lodash/includes.js';
import { delay } from '@/Helpers.js';
import Activities from './activities/index.js';
import CourseForm from './courseform.js';
import GradingSchemes from './gradingschemes/index.js';
import Notes from './notes/index.js';
import Presentations from './presentations/index.js';
import Quizzes from './quizzes/index.js';
import RubricBanks from './rubricbanks/index.js';
import Rubrics from './rubrics/index.js';
import Sections from './sections.js';
import SlideDecks from './slidedecks/slide-decks.js';
import Videos from './videos/videos.js';

const subscriptions = {
    ...CourseForm,
    ...Sections,
    ...Activities,
    ...Rubrics,
    ...SlideDecks,
    ...Videos,
    ...Presentations,
    ...Notes,
    ...RubricBanks,
    ...GradingSchemes,
    ...Quizzes,
};

export default store => {
    const timer = import.meta.env.VITE_APP_DEBUG === 'true' ? 500 : 2000;

    const validMutation = mutation => {
        const allowedFromCollection =
            has(subscriptions, mutation.type) && includes(subscriptions[mutation.type].fields, mutation.payload.field);

        const allowedFromVuexOrm =
            has(subscriptions, mutation.type) && includes(subscriptions[mutation.type].entity, mutation.payload.entity);

        return allowedFromCollection || allowedFromVuexOrm;
    };

    store.subscribe(mutation => {
        if (validMutation(mutation)) {
            delay({
                callback: () => {
                    subscriptions[mutation.type].callback(store, mutation);
                },
                ms: timer,
                uuid: mutation.payload.uuid,
            });
        }
    });
};
